import { defineMessage } from 'react-intl';

/** Label shown when a user id cannot be resolved (e.g. deleted user). */
export const unknownUserMessage = defineMessage({
  id: 'users.chipList.unknownUser',
  defaultMessage: 'Usuario desconocido',
});
